import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import AvatarUploader from '../AvatarUploader';
import MembersList from '../Members/MembersList';
import DeleteConfrimModal from './DeleteConfrimModal';

class TeamDetail extends Component {
  constructor() {
    super();
    this.state = {
      avatar: '',
      name: '',
      loading: false,
      openModal: false,
    };
  }

  componentWillMount() {
    const { params } = this.props;

    this.props.loadTeam(params.teamId);
    this.props.loadMembers(params.teamId);
  }

  componentWillReceiveProps(nextProps) {
    const { status, team } = nextProps;

    if (status !== this.props.status) {
      if (status === actionTypes.TEAM_GET_SUCCESS && team) {
        this.setState({ name: team.name, avatar: team.avatar });
      } else if (
        status === actionTypes.TEAM_DELETE_SUCCESS ||
        status === actionTypes.TEAM_ARCHIVE_SUCCESS
      ) {
        this.props.router.push(`/teams`);
      } else if (status === actionTypes.TEAM_DELETE_ERROR) {
        this.props.hideAlert();
        this.props.alert(
          'error',
          'Oops! cannot delete the team because collaborator is already included on an agreement.'
        );
      } else if (status === actionTypes.TEAM_ARCHIVE_ERROR) {
        this.props.hideAlert();
        this.props.alert('error', 'Oops! cannot archvie the team.');
      } else if (status === actionTypes.TEAM_UPDATE_ERROR) {
        this.setState({ loading: false });
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try to again. If this error persists, please contact us.'
        );
      } else if (status === actionTypes.TEAM_UPDATE_SUCCESS) {
        this.setState({ loading: false });
        this.props.alert('success', "Your team's details have been saved.");
      }
    }
  }

  handleUpload(file) {
    if (file && file.url) {
      this.setState({ avatar: file.url });
    } else {
      this.setState({ avatar: '' });
    }
  }

  save(e) {
    e.preventDefault();

    const { profile, params, members } = this.props;

    this.props.hideAlert();

    let data = {
      name: this.state.name,
      avatar: this.state.avatar,
      user: profile.id,
    };

    if (members && members.length > 1) {
      this.setState({ loading: true }, () => {
        this.props.save(params.teamId, data);
      });
    } else {
      let canCreateOwnMember =
        _.findIndex(
          members,
          (member) => member.user_info.email === profile.email
        ) === -1;
      if (profile.subscription_plan === 'pro-annual') {
        canCreateOwnMember = false;
      }
      if (canCreateOwnMember) {
        this.props.alert(
          'error',
          'A team must contain at least 2 people, including yourself.'
        );
      } else {
        this.props.alert('error', 'A team must contain at least 2 people.');
      }
    }
  }

  delete() {
    this.props.deleteTeam(this.props.params.teamId);
    this.onCloseModal();
  }

  archive() {
    this.props.archiveTeam(this.props.params.teamId);
    this.onCloseModal();
  }

  onCloseModal() {
    this.setState({ openModal: false });
  }

  confirmDelete() {
    this.props.hideAlert();
    this.setState({ openModal: true });
  }

  render() {
    const { name, avatar, loading, openModal } = this.state;

    return (
      <div className="create-team">
        <Heading text="Team details" />
        <Form onSubmit={(e) => this.save(e)}>
          <Row>
            <Col md={3}>
              <div className="team-photo text-center upload-photo">
                <AvatarUploader
                  size="120"
                  image={avatar}
                  onUpload={(file) => this.handleUpload(file)}
                >
                  <span className="text-gray btn-upload-photo">Team photo</span>
                </AvatarUploader>
              </div>
            </Col>
            <Col md={7}>
              <div className="team-name">
                <FormGroup>
                  <FormControl
                    type="text"
                    placeholder="Click here to give your team a name"
                    value={name}
                    onChange={(e) => this.setState({ name: e.target.value })}
                    required
                  />
                </FormGroup>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={9} mdOffset={3}>
              <MembersList />
            </Col>
          </Row>
          <div className="step-nav">
            <NavButtons
              direction="back"
              prev={() => this.props.router.push('/teams')}
            />
            <div>
              <Button
                bsStyle="link"
                className="btn-delete"
                onClick={() => this.confirmDelete()}
              >
                delete or archive
              </Button>
              <button type="submit">
                {loading && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                Save
              </button>
            </div>
          </div>
        </Form>

        <DeleteConfrimModal
          open={openModal}
          mode="all"
          delete={() => this.delete()}
          archive={() => this.archive()}
          onClose={() => this.onCloseModal()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.teams.status,
  team: state.teams.selectedTeam,
  members: state.users.members,
  profile: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadTeam: (teamId) => {
    dispatch(actions.getTeam(teamId));
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  save: (teamId, data) => {
    dispatch(actions.updateTeam(teamId, data));
  },
  deleteTeam: (teamId) => {
    dispatch(actions.deleteTeam(teamId));
  },
  archiveTeam: (teamId) => {
    dispatch(actions.archiveTeam(teamId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamDetail);



// WEBPACK FOOTER //
// src/components/Teams/TeamDetail.jsx